export default __webpack_public_path__ + "media/images/logo-73cdc23c7535f7054d5c325f2bb5f1ca.svg";